/* eslint-disable func-names */
import { Dialog } from "@mui/material";
import React from "react";

function CustomModal(Children) {
  return function (props) {
    return (
      <Dialog onClose={props?.handleShowModal} open={props?.showModal} className={props?.className}>
        <Children {...props} />
      </Dialog>
    );
  };
}
export default CustomModal;
